import { Route, Routes } from "react-router-dom";
import {
  APP_ROUTES,
  APP_NOT_FOUND_ROUTE,
} from "@/routes/appRoutes";

export function AppRouteSwitch() {
  return (
    <Routes>
      {APP_ROUTES.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={route.element}
        />
      ))}
      <Route
        path={APP_NOT_FOUND_ROUTE.path}
        element={APP_NOT_FOUND_ROUTE.element}
      />
    </Routes>
  );
}
